import React, { useState } from 'react';
import { Box, Typography, Button, Card, CardContent } from '@mui/material';
import apiService from '../services/api';

const ApiTest: React.FC = () => {
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const setTestToken = () => {
    const testToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2ODQ4MTNkM2E5M2RjODE4MGI0MDJiZDgiLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE3NTE0NTg2MzgsImV4cCI6MTc1MTU0NTAzOH0.6WgvF_n7Dia0wSkv2DjqWcHCSKDb4-qWfdAMdS8lNHc';
    
    localStorage.setItem('token', testToken);
    localStorage.setItem('user', JSON.stringify({
      id: '684813d3a93dc8180b402bd8',
      username: 'admin',
      role: 'admin'
    }));
    
    console.log('Test token set in localStorage');
    alert('Test token set!');
  };

  const testContractDataAPI = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      console.log('Testing contract data API...');
      const response = await apiService.get('/api/members/684f8afd7cb3474893541b9a/contract-data');
      console.log('API response:', response);
      setResult(response);
    } catch (err: any) {
      console.error('API error:', err);
      setError(err.message || 'API call failed');
    } finally {
      setLoading(false);
    }
  };

  const clearToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    alert('Token cleared!');
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        API Test Page
      </Typography>
      
      <Box mb={2}>
        <Button variant="contained" onClick={setTestToken} sx={{ mr: 2 }}>
          Set Test Token
        </Button>
        <Button variant="outlined" onClick={clearToken} sx={{ mr: 2 }}>
          Clear Token
        </Button>
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={testContractDataAPI}
          disabled={loading}
        >
          {loading ? 'Testing...' : 'Test Contract Data API'}
        </Button>
      </Box>

      {error && (
        <Card sx={{ mb: 2, bgcolor: 'error.light' }}>
          <CardContent>
            <Typography variant="h6" color="error">
              Error
            </Typography>
            <Typography>{error}</Typography>
          </CardContent>
        </Card>
      )}

      {result && (
        <Card sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              API Result
            </Typography>
            <Typography variant="body2" component="pre" sx={{ whiteSpace: 'pre-wrap' }}>
              {JSON.stringify(result, null, 2)}
            </Typography>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default ApiTest;
